import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GridsterConfig, GridType } from 'angular-gridster2';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'app/shared/models/subject';

@Component({
  selector: 'card-widget',
  templateUrl: './card-widget.component.html',
  styleUrls: ['./card-widget.component.scss'],
  animations: fuseAnimations,
})
export class CardWidgetComponent implements OnInit {
  public options: GridsterConfig;
  public _widgets = [];
  public gridSize = 30;

  @Input() id: number;
  @Input() subjectId: string;
  @Input() processTypeId: string;
  @Input() settings: any;
  @Input() title: string;
  @Input() secondaryTitle: string;
  @Input() titleBackgroundColor: string;
  @Input() allowEdit: boolean;
  @Input() markers: number;
  @Input() restricted: boolean;
  @Input() widgetStyle: any;
  @Input() deadlineDaysLeft: number = 999999;
  @Input() useWorkingDays: boolean = true;

  @Input() set widgets(val: any[]) {
    this._widgets = [...val];
    const length = this._widgets.length;
    for (let i = 0; i < length; i++) {
      if (this._widgets[i]?.metadata?.value === 'Invalid Date') {
        this._widgets[i].metadata.value = '';
      }
    }
  }

  @Output() onEdit = new EventEmitter();

  deadlineDaysLeftText: string="";

  constructor() { }

  ngOnInit() {
    // set gridster options
    this.options = {
      gridType: GridType.Fixed,
      fixedColWidth: this.gridSize,
      fixedRowHeight: this.gridSize,
      mobileBreakpoint: this.gridSize * 10,
      margin: 0,
      minCols: 1,
      maxCols: 50,
      minRows: 1,
      maxRows: 100,
      draggable: {
        enabled: false,
      },
      resizable: {
        enabled: false,
      },
    };

    this.deadlineDaysLeftText = Subject.getDeadlineText(this.useWorkingDays, this.deadlineDaysLeft);    
  }

  edit() {
    this.onEdit.emit();
  }
}
